export default {
  howItWorks: {
    label: 'How It Works',
    pathname: '/#how-it-works',
    shouldUseHashLink: true,
  },
  foundSomething: {
    pathname: '/found-something',
    label: 'Found Something?',
  },
  registerYourTag: {
    label: 'Register',
    pathname: '/register',
  },
  buyNow: {
    label: 'Buy a Tag',
    pathname: 'https://ownerfy.com/',
    external: true,
  },
  dashboard: {
    label: 'Dashboard',
    pathname: '/dashboard',
    needsAuth: true,
  },
  contact: {
    label: 'Contact',
    pathname: '/contact',
  },
  privacyPolicy: {
    label: 'Privacy Policy',
    pathname: '/privacy-policy',
  },
  tos: {
    label: 'Terms of Use',
    pathname: '/TOS',
  },
  registrationDashboard: {
    label: 'Dashboard',
    pathname: '/product-registration/dashboard',
    needsAuth: true,
  },
  registrationCustomers: {
    label: 'Customers',
    pathname: '/product-registration/customers',
    needsAuth: true,
  },
  registrationAddCode: {
    label: 'Add Code',
    pathname: '/product-registration/add-code',
    needsAuth: true,
  },
  joinDiscord: {
    label: 'Join Us on Discord',
    pathname: 'https://discord.com/invite/vMPW2z9vYR',
    external: true,
  },
  downloadNftCreator: {
    label: 'Download NFT Creator',
    pathname: 'https://shop.ownerfy.com/pages/download-ownerfy-nft-creator',
    external: true,
  },
  moreSecureNfts: {
    label: 'Better, More Secure NFTs',
    pathname: 'https://shop.ownerfy.com/pages/the-most-secure-nfts',
    external: true,
  },
  howToMakeNfts: {
    label: 'How to Make NFTs',
    pathname: 'https://shop.ownerfy.com/pages/how-to-make-nfts',
    external: true,
  },
};
